import React, { lazy } from "react";
import "../componnetsCss/SignIn.css";
import { useState, useEffect } from "react";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { getDatabase, ref, onValue, update } from "firebase/database";
import { app } from "../Firebase";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./Home";
import Figure from "react-bootstrap/Figure";
import Card from "react-bootstrap/Card";
import { FaAccusoft, FaUser } from "react-icons/fa";
import UserActive from "./UserActive";
import Giveaway from "./Giveaway";

const SignIn = () => {
  const [checkPass, setCheckPass] = useState(false);
  //Sign In User Statessss.............................
  const [email, SetEmail] = useState();
  const [password, SetPassword] = useState();
  let currentDateTime = new Date().toISOString();
  let currentDate = new Date().getDate();
  let currentHours = new Date().getHours();
  let currentMinutes = new Date().getMinutes();
  let currentSecond = new Date().getSeconds();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const activities = [
  "Ali Khan earned RS 250 confirm watching video",
    "Zeeshan just withdrew RS 1,200 via EasyPaisa",
    "Sara Ahmed upgraded to Package 1",
    "Usman Ahmed earned RS 180 confirm watching video",
    "Hamza just upgraded to Package 2",
    "Ayesha withdrew RS 2,500 via JazzCash",
    "Bilal Siddiqui earned RS 350 confirm watching video",
    "Sana Malik upgraded to Package 3",
    "Omer Farooq earned RS 120 confirm watching video",
    "Maria Khan withdrew RS 4,800 via Bank Transfer",
    "Fahad Mustafa earned RS 500 confirm watching video",
    "Raza Ali upgraded to Package 1",
    "Nida Sheikh earned RS 210 confirm watching video",
    "Kashif Jameel withdrew RS 950 via EasyPaisa",
    "Hina Pervez earned RS 400 confirm watching video",
    "Tanveer Ahmed upgraded to Package 2",
    "Zainab Bibi earned RS 150 confirm watching video",
    "Waqas Khan withdrew RS 3,200 via JazzCash",
    "Asma Gull earned RS 280 confirm watching video",
    "Adnan Malik upgraded to Package 1",
    "Shoaib Akhtar earned RS 600 confirm watching video",
    "Mehak Jan withdrew RS 1,500 via EasyPaisa",
    "Farhan Saeed upgraded to Package 3",
    "Iqra Aziz earned RS 220 confirm watching video",
    "Salman Shah deposited RS 500 for Package 1",
    "Tayyaba Khan upgraded to Package 2",
    "Haris Rauf earned RS 450 confirm watching video",
    "Nimra Ahmed withdrew RS 2,200 via JazzCash",
    "Junaid Khan earned RS 190 confirm watching video",
    "Babar Azam upgraded to Package 1",
    "Saba Qamar earned RS 310 confirm watching video",
    "Muneeb Butt withdrew RS 5,000 via EasyPaisa",
    "Arsalan Ash earned RS 240 confirm watching video",
    "Kubra Khan upgraded to Package 3",
    "Danish Taimoor earned RS 170 confirm watching video",
    "Fiza Ali withdrew RS 1,800 via Bank Transfer",
    "Imran Abbas upgraded to Package 1",
    "Maya Ali earned RS 420 confirm watching video",
    "Shehryar Munawar deposited RS 1,000 for Package 2",
    "Sajal Aly upgraded to Package 2",
    "Ahad Raza Mir earned RS 130 confirm watching video",
    "Yumna Zaidi withdrew RS 2,900 via EasyPaisa",
    "Bilal Abbas upgraded to Package 3",
    "Sanam Saeed earned RS 380 confirm watching video",
    "Fawad Khan withdrew RS 4,500 via JazzCash",
    "Mahira Khan upgraded to Package 1",
    "Ushna Shah earned RS 260 confirm watching video",
    "Gohar Rasheed withdrew RS 1,100 via EasyPaisa",
    "Sana Javed upgraded to Package 2",
    "Mikaal Zulfiqar earned RS 550 confirm watching video",
    "Adeel Hussain earned RS 290 confirm watching video",
    "Kiran Haq just withdrew RS 2,000 via EasyPaisa",
    "Feroze Khan upgraded to Package 3",
    "Sana Khan earned RS 140 confirm watching video",
    "Madiha Imam just upgraded to Package 1",
    "Azfar Rehman withdrew RS 3,400 via JazzCash",
    "Soniya Hussain earned RS 470 confirm watching video",
    "Asad Siddiqui upgraded to Package 2",
    "Yasir Hussain earned RS 110 confirm watching video",
    "Iqra Aziz withdrew RS 6,000 via Bank Transfer",
    "Agha Ali earned RS 520 confirm watching video",
    "Hina Altaf upgraded to Package 1",
    "Sami Khan earned RS 230 confirm watching video",
    "Zahid Ahmed withdrew RS 850 via EasyPaisa",
    "Minal Khan earned RS 410 confirm watching video",
    "Aiman Khan upgraded to Package 3",
    "Amna Ilyas earned RS 160 confirm watching video",
    "Sheheryar Munawar withdrew RS 3,800 via JazzCash",
    "Ramsha Khan earned RS 275 confirm watching video",
    "Affan Waheed upgraded to Package 2",
    "Sarah Khan earned RS 620 confirm watching video",
    "Noor Hassan withdrew RS 1,700 via EasyPaisa",
    "Mansha Pasha upgraded to Package 3",
    "Ali Rehman Khan earned RS 215 confirm watching video",
    "Usman Khalid deposited RS 500 for Package 1",
    "Sanam Jung upgraded to Package 2",
    "Ahmed Ali Akbar earned RS 440 confirm watching video",
    "Hareem Farooq withdrew RS 2,400 via JazzCash",
    "Azra Mohyeddin earned RS 195 confirm watching video",
    "Shabbir Jan upgraded to Package 1",
    "Rubina Ashraf earned RS 320 confirm watching video",
    "Mahmood Aslam withdrew RS 5,500 via EasyPaisa",
    "Sohai Ali Abro earned RS 245 confirm watching video",
    "Ayesha Omar upgraded to Package 3",
    "Aziz Jibran earned RS 175 confirm watching video",
    "Zeba Bakhtiar withdrew RS 1,900 via Bank Transfer",
    "Javed Sheikh upgraded to Package 1",
    "Bushra Ansari earned RS 430 confirm watching video",
    "Behroze Sabzwari deposited RS 1,000 for Package 2",
    "Shahroz Sabzwari upgraded to Package 2",
    "Syra Yousuf earned RS 135 confirm watching video",
    "Sadaf Kanwal withdrew RS 3,000 via EasyPaisa",
    "Shehroz Ahmed upgraded to Package 3",
    "Navin Waqar earned RS 390 confirm watching video",
    "Ahsan Khan withdrew RS 4,700 via JazzCash",
    "Sarwat Gilani upgraded to Package 1",
    "Nimra Khan earned RS 265 confirm watching video",
    "Zubab Rana withdrew RS 1,250 via EasyPaisa",
    "Noor Zafar Khan upgraded to Package 2",
    "Wahaj Ali earned RS 560 confirm watching video",
    "Hiba Qadir earned RS 305 confirm watching video",
    "Areeba Habib just withdrew RS 2,100 via EasyPaisa",
    "Saad Qureshi upgraded to Package 3",
    "Kinza Hashmi earned RS 155 confirm watching video",
    "Ali Ansari just upgraded to Package 1",
    "Saboor Aly withdrew RS 3,600 via JazzCash",
    "Mariyam Nafees earned RS 480 confirm watching video",
    "Gohar Mumtaz upgraded to Package 2",
    "Asim Azhar earned RS 115 confirm watching video",
    "Momina Mustehsan withdrew RS 6,200 via Bank Transfer",
    "Umair Jaswal earned RS 530 confirm watching video",
    "Sana Shahnawaz upgraded to Package 1",
    "Samina Peerzada earned RS 235 confirm watching video",
    "Usman Peerzada withdrew RS 880 via EasyPaisa",
    "Hammad Shoaib earned RS 415 confirm watching video",
    "Arisha Razi upgraded to Package 3",
    "Zain Afzal earned RS 165 confirm watching video",
    "Faizan Sheikh withdrew RS 3,900 via JazzCash",
    "Rabia Butt earned RS 285 confirm watching video",
    "Emaan Suleman upgraded to Package 2",
    "Amna Babar earned RS 630 confirm watching video",
    "Hasnain Lehri withdrew RS 1,750 via EasyPaisa",
    "Sabeeka Imam upgraded to Package 3",
    "Fouzia Aman earned RS 225 confirm watching video",
    "Shahzad Noor deposited RS 500 for Package 1",
    "Alyzeh Gabol upgraded to Package 2",
    "Sadaf Khan earned RS 445 confirm watching video",
    "Mehreen Syed withdrew RS 2,450 via JazzCash",
    "Iffat Omar earned RS 205 confirm watching video",
    "Juggun Kazim upgraded to Package 1",
    "Shaista Lodhi earned RS 325 confirm watching video",
    "Nida Pasha withdrew RS 5,600 via EasyPaisa",
    "Faysal Qureshi earned RS 255 confirm watching video",
    "Sajal Mir upgraded to Package 3",
    "Ahad Mir earned RS 185 confirm watching video",
    "Saboor Ali withdrew RS 1,950 via Bank Transfer",
    "Minal Ahsan upgraded to Package 1",
    "Aiman Muneeb earned RS 435 confirm watching video",
    "Muneeb Muneeb deposited RS 1,000 for Package 2",
    "Urwa Hocane upgraded to Package 2",
    "Farhan Saeed Mir earned RS 145 confirm watching video",
    "Mawra Hocane withdrew RS 3,100 via EasyPaisa",
    "Haroon Shahid upgraded to Package 3",
    "Ramsha Khan Ali earned RS 395 confirm watching video",
    "Bilal Saeed withdrew RS 4,800 via JazzCash",
    "Aima Baig upgraded to Package 1",
    "Sahir Ali Bagga earned RS 275 confirm watching video",
    "Nabeel Shaukat withdrew RS 1,300 via EasyPaisa",
    "Rahat Fateh Ali upgraded to Package 2",
    "Atif Aslam earned RS 570 confirm watching video",
    "Ali Zafar earned RS 315 confirm watching video",
    "Shani Arshad just withdrew RS 2,200 via EasyPaisa",
    "Hadiqa Kiani upgraded to Package 3",
    "Quratulain Balouch earned RS 165 confirm watching video",
    "Zeb Bangash just upgraded to Package 1",
    "Annie Khalid withdrew RS 3,700 via JazzCash",
    "Amanat Ali earned RS 490 confirm watching video",
    "Fariha Pervez upgraded to Package 2",
    "Humaira Arshad earned RS 125 confirm watching video",
    "Jawad Ahmed withdrew RS 6,400 via Bank Transfer",
    "Ali Azmat earned RS 540 confirm watching video",
    "Strings Band upgraded to Package 1",
    "Noori Band earned RS 245 confirm watching video",
    "Farhad Humayun withdrew RS 920 via EasyPaisa",
    "Goher Mumtaz earned RS 425 confirm watching video",
    "Mizraab Band upgraded to Package 3",
    "Call Band earned RS 175 confirm watching video",
    "Entity Paradigm withdrew RS 4,100 via JazzCash",
    "Junaid Jamshed earned RS 295 confirm watching video",
    "Vital Signs upgraded to Package 2",
    "Junoon Band earned RS 640 confirm watching video",
    "Abida Parveen withdrew RS 1,850 via EasyPaisa",
    "Nusrat Fateh Ali upgraded to Package 3",
    "Arif Lohar earned RS 235 confirm watching video",
    "Sanam Marvi deposited RS 500 for Package 1",
    "Saien Zahoor upgraded to Package 2",
    "Attaullah Khan earned RS 455 confirm watching video",
    "Mansoor Malangi withdrew RS 2,550 via JazzCash",
    "Allah Ditta earned RS 215 confirm watching video",
    "Pathanay Khan upgraded to Package 1",
    "Reshma Bibi earned RS 335 confirm watching video",
    "Zarsanga Bibi withdrew RS 5,700 via EasyPaisa",
    "Gul Panra earned RS 265 confirm watching video",
    "Hamayoon Khan upgraded to Package 3",
    "Bakhtiyar Khattak earned RS 195 confirm watching video",
    "Zeek Afridi withdrew RS 2,050 via Bank Transfer",
    "Khyal Muhammad upgraded to Package 1",
    "Rafiq Shinwari earned RS 445 confirm watching video",
    "Gulnar Bibi deposited RS 1,000 for Package 2",
    "Nagmanat Bibi upgraded to Package 2",
    "Kishwar Sultan earned RS 155 confirm watching video",
    "Munir Sarhadi withdrew RS 3,200 via EasyPaisa",
    "Ustad Nusrat upgraded to Package 3",
    "Sabri Brothers earned RS 405 confirm watching video",
    "Aziz Mian withdrew RS 4,900 via JazzCash",
    "Sher Ali Khan upgraded to Package 1",
    "Mehr Ali Khan earned RS 285 confirm watching video",
    "Badar Miandad withdrew RS 1,400 via EasyPaisa",
    "Faiz Ali Faiz upgraded to Package 2",
    "Rahat Ali earned RS 580 confirm watching video",
    "Farrukh Fateh earned RS 325 confirm watching video",
    "Dildar Pervez just withdrew RS 2,300 via EasyPaisa",
    "Mubarak Ali upgraded to Package 3",
    "Salamar Ali earned RS 175 confirm watching video",
    "Shujat Ali just upgraded to Package 1",
    "Asad Amanat withdrew RS 3,800 via JazzCash",
    "Shafqat Amanat earned RS 500 confirm watching video",
    "Hameed Ali upgraded to Package 2",
    "Fateh Ali Khan earned RS 135 confirm watching video",
    "Rustam Fateh withdrew RS 6,600 via Bank Transfer",
    "Sultan Fateh earned RS 550 confirm watching video",
    "Ustad Amanat upgraded to Package 1",
    "Ustad Bade Ghulam earned RS 255 confirm watching video",
    "Ustad Salamat withdrew RS 960 via EasyPaisa",
    "Ustad Nazakat earned RS 435 confirm watching video",
    "Ustad Shaukat upgraded to Package 3"]
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Pehle purani value fade out hogi

      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % activities.length);
        setFade(true); // Nayi value fade in hogi
      }, 500); // 0.5 second ka gap transition ke liye

    }, 4000); // Har 4 second baad change hoga

    return () => clearInterval(interval);
  }, [activities.length]);


  ///////////For Navigation
  const navigate = useNavigate();
  const accessForHome = (passId) => {
    console.log(passId);
    navigate("/home", { state: passId });
  };

  const auth = getAuth(app);
  const signInUser = () => {
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        console.log(`successs`);
        const passId = user.uid;
        accessForHome(passId);
        const db = getDatabase(app);
        const aas = ref(db, `${passId}`);

        // const collect = showBal + 50;

        update(aas, {
          UserLastSeen: ` Date ${currentDate}: ${currentHours}H : ${currentMinutes}M : ${currentSecond}S  `,
          WithdrewlAmount: {
            value1: 165,
            value2: 350,
            value3: 550,
            value4: 650,
            value5: 960,
          }
        });
        const aaas = ref(db, `Active Users / ${passId}`);

        update(aaas, {
          UserLastSeen: ` Date ${currentDate}: `,
          Email: email,
        });
        update(aas, {
          UserLastSeen: ` Date ${currentDate}: ${currentHours}H : ${currentMinutes}M : ${currentSecond}S  `,
        });
        const aaaas = ref(db, `new/users ${currentDate}/`);

        update(aaaas, {
          id: passId,
        });

      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorMessage);
        signInErr(errorMessage);
      });
  };

  const signInErr = (errorMessage) => {
    if (errorMessage === "Firebase: Error (auth/missing-email).") {
      const notify = () => toast.error("Enter Your Email");
      notify();
    } else if (errorMessage === "Firebase: Error (auth/missing-password).") {
      const notify = () => toast.error("Enter Your Password");
      notify();
    } else if (errorMessage === `Firebase: Error (auth/invalid-credential).`) {
      const notify = () => toast.error("User Not Found");
      notify();
    } else if (errorMessage === `Firebase: Error (auth/user-disabled).`) {
      const notify = () =>
        toast.error("Your account has been disabled due to a violation ");
      notify();
    }
  };

  ///////////////////This Function is password hide and show
  const chkPass = () => {
    if (checkPass == false) {
      setCheckPass(true);
    } else {
      setCheckPass(false);
    }
  };

  const items = [

    "Haris from Lahore earned RS 150 from Watching Video",
    "Deposit RS 1,000 successful via EasyPaisa - Package 2 Activated",
    "Zubair: Withdrawal RS 1,450 successful via JazzCash",
    "Asma Bibi earned RS 280 from Watching Video",
    "Sajid Ali upgraded to Package 1",
    "Withdrawal RS 850 successful via EasyPaisa - Instant",
    "Mehak from Multan earned RS 410 from Watching Video",
    "Deposit RS 500 successful via JazzCash - Account Updated",
    "Faisal Khan: Withdrawal RS 1,900 successful via Bank Account",
    "Iqra Malik earned RS 320 from Watching Video",
    "Naveed upgraded to Package 3",
    "Withdrawal RS 1,200 successful via EasyPaisa - Confirmed",
    "Kashif earned RS 190 from Watching Video",
    "Deposit RS 2,000 successful via EasyPaisa - VIP Status Active",
    "Sana from Pindi: Withdrawal RS 1,650 successful via JazzCash",
    "Bilal earned RS 440 from Watching Video",
    "Package 1 Activated for User ID: 99283",
    "Hamza: Withdrawal RS 700 successful via EasyPaisa",
    "Zainab Bibi earned RS 215 from Watching Video",
    "Deposit RS 1,500 successful via JazzCash - Wallet Updated",
    "Yasir Khan: Withdrawal RS 1,100 successful via EasyPaisa",
    "Tayyaba earned RS 370 from Watching Video",
    "Arsalan upgraded to Package 2",
    "Withdrawal RS 1,300 successful via JazzCash - Paid",
    "Ali Raza earned RS 260 from Watching Video",
    "Deposit RS 400 successful via EasyPaisa - Starter Pack",
    "Hassan: Withdrawal RS 1,850 successful via Bank Transfer",
    "Nida Ahmed earned RS 140 from Watching Video",
    "Salman upgraded to Package 1",
    "Withdrawal RS 950 successful via EasyPaisa - Sent",
    "Usman from Gujrat earned RS 520 from Watching Video",
    "Deposit RS 1,200 successful via JazzCash - Approved",
    "Maria: Withdrawal RS 1,550 successful via JazzCash",
    "Farhan earned RS 310 from Watching Video",
    "Shadab upgraded to Package 3",
    "Withdrawal RS 1,400 successful via EasyPaisa - Received",
    "Ayesha from Sialkot earned RS 185 from Watching Video",
    "Deposit RS 800 successful via EasyPaisa - Confirmed",
    "Rizwan: Withdrawal RS 1,700 successful via JazzCash",
    "Tayyab earned RS 435 from Watching Video",
    "Muneeb upgraded to Package 2",
    "Withdrawal RS 1,150 successful via EasyPaisa - Instant",
    "Saba earned RS 295 from Watching Video",
    "Deposit RS 2,000 successful via Bank Account - Processing",
    "Jawad: Withdrawal RS 1,300 successful via JazzCash",
    "Fahad earned RS 225 from Watching Video",
    "Ishaq upgraded to Package 1",
    "Withdrawal RS 880 successful via EasyPaisa - Paid",
    "Nimra earned RS 365 from Watching Video",
    "Deposit RS 600 successful via JazzCash - Verified",
    "Saad from Okara: Withdrawal RS 1,420 successful via EasyPaisa",
    "Zunaira earned RS 480 from Watching Video",
    "Babar upgraded to Package 3",
    "Withdrawal RS 1,950 successful via Bank Transfer",
    "Irfan earned RS 130 from Watching Video",
    "Deposit RS 1,000 successful via EasyPaisa - Package Active",
    "Bushra: Withdrawal RS 1,250 successful via JazzCash",
    "Kamran earned RS 550 from Watching Video",
    "Noman upgraded to Package 1",
    "Withdrawal RS 920 successful via EasyPaisa - Sent",
    "Seema earned RS 340 from Watching Video",
    "Deposit RS 1,500 successful via JazzCash - Package 2 Active",
    "Hassan: Withdrawal RS 1,100 successful via EasyPaisa",
    "Sumaira earned RS 215 from Watching Video",
    "Javed upgraded to Package 2",
    "Withdrawal RS 1,350 successful via JazzCash - Confirmed",
    "Shahid earned RS 405 from Watching Video",
    "Madiha: Withdrawal RS 1,600 successful via EasyPaisa",
    "Umar upgraded to Package 3",
    "Deposit RS 500 successful via EasyPaisa - Instant Credit",
    "Abid earned RS 175 from Watching Video",
    "Rameez: Withdrawal RS 1,800 successful via Bank Account",
    "Bismah earned RS 495 from Watching Video",
    "Misbah upgraded to Package 1",
    "Withdrawal RS 1,100 successful via JazzCash - Paid",
    "Shaheen earned RS 315 from Watching Video",
    "Saeed: Withdrawal RS 1,450 successful via EasyPaisa",
    "Imad upgraded to Package 2",
    "Deposit RS 2,000 successful via JazzCash - VIP Active",
    "Muneeba earned RS 245 from Watching Video",
    "Sarfaraz: Withdrawal RS 1,200 successful via JazzCash",
    "Azhar earned RS 485 from Watching Video",
    "Sohaib upgraded to Package 3",
    "Withdrawal RS 1,550 successful via EasyPaisa - Sent",
    "Wahab earned RS 165 from Watching Video",
    "Asif: Withdrawal RS 1,300 successful via JazzCash",
    "Faheem upgraded to Package 1",
    "Deposit RS 400 successful via EasyPaisa - Approved",
    "Shadab earned RS 385 from Watching Video",
    "Rizwan: Withdrawal RS 1,150 successful via EasyPaisa",
    "Fakhar upgraded to Package 2",
    "Withdrawal RS 1,400 successful via JazzCash - Instant",
    "Iftikhar earned RS 275 from Watching Video",
    "Khurram: Withdrawal RS 1,650 successful via EasyPaisa",
    "Abrar upgraded to Package 3",
    "Deposit RS 1,200 successful via Bank Transfer",
    "Mir Hamza earned RS 440 from Watching Video",
    "Saim: Withdrawal RS 900 successful via JazzCash",
    "Tayyab upgraded to Package 1",
    "Withdrawal RS 1,750 successful via EasyPaisa - Paid",
    "Zaman earned RS 195 from Watching Video",
    "Deposit RS 800 successful via JazzCash - Verified",
    "Anwar: Withdrawal RS 1,300 successful via Bank Account",
    "Sohail earned RS 320 from Watching Video",
    "Yasir upgraded to Package 2",
    "Withdrawal RS 1,100 successful via EasyPaisa - Instant",
    "Rahat earned RS 510 from Watching Video",
    "Junaid: Withdrawal RS 1,450 successful via JazzCash",
    "Sohail upgraded to Package 3",
    "Deposit RS 2,000 successful via EasyPaisa - Instant Credit",
    "Ishaq earned RS 235 from Watching Video",
    "Maryam: Withdrawal RS 1,800 successful via JazzCash",
    "Imran upgraded to Package 1",
    "Arshad: Withdrawal RS 1,100 successful via EasyPaisa",
    "Qasim earned RS 415 from Watching Video",
    "Sahir: Withdrawal RS 1,500 successful via JazzCash",
    "Iqrar upgraded to Package 2",
    "Tariq earned RS 360 from Watching Video",
    "Deposit RS 500 successful via EasyPaisa - Package Active",
    "Sham: Withdrawal RS 1,300 successful via EasyPaisa",
    "Shahveer upgraded to Package 3",
    "Ducky earned RS 540 from Watching Video",
    "Moro: Withdrawal RS 1,650 successful via JazzCash",
    "Junejo upgraded to Package 1",
    "Amna earned RS 230 from Watching Video",
    "Fatima: Withdrawal RS 1,200 successful via EasyPaisa",
    "Zainab upgraded to Package 2",
    "Withdrawal RS 920 successful via JazzCash - Paid",
    "Kulsoom earned RS 415 from Watching Video",
    "Rubab upgraded to Package 3",
    "Withdrawal RS 1,700 successful via EasyPaisa",
    "Naseem earned RS 205 from Watching Video",
    "Bakhtawar upgraded to Package 1",
    "Deposit RS 1,500 successful via Bank Transfer",
    "Ali Amin earned RS 490 from Watching Video",
    "Pervaiz: Withdrawal RS 1,250 successful via EasyPaisa",
    "Fawad upgraded to Package 2",
    "Shireen earned RS 175 from Watching Video",
    "Sheikh Rasheed: Withdrawal RS 950 successful via JazzCash",
    "Khawaja upgraded to Package 3",
    "Sherry earned RS 335 from Watching Video",
    "Yousuf: Withdrawal RS 1,800 successful via EasyPaisa",
    "Raja upgraded to Package 1",
    "Latif earned RS 420 from Watching Video",
    "Babar: Withdrawal RS 1,550 successful via JazzCash",
    "Mustafa upgraded to Package 2",
    "Farooq earned RS 395 from Watching Video",
    "Khalid: Withdrawal RS 1,100 successful via EasyPaisa",
    "Mehwish upgraded to Package 3",
    "Withdrawal RS 1,450 successful via JazzCash",
    "Naila earned RS 225 from Watching Video",
    "Uzma upgraded to Package 1",
    "Withdrawal RS 1,300 successful via EasyPaisa",
    "Fiza earned RS 190 from Watching Video",
    "Samina upgraded to Package 2",
    "Deposit RS 2,000 successful via JazzCash",
    "Kiran: Withdrawal RS 1,150 successful via EasyPaisa",
    "Sonia earned RS 465 from Watching Video",
    "Ambreen upgraded to Package 3",
    "Withdrawal RS 1,750 successful via JazzCash",
    "Maliha earned RS 340 from Watching Video",
    "Saira upgraded to Package 1",
    "Withdrawal RS 920 successful via EasyPaisa",
    "Rabia earned RS 270 from Watching Video",
    "Hina upgraded to Package 2",
    "Withdrawal RS 1,600 successful via JazzCash",
    "Laila earned RS 510 from Watching Video",
    "Sanam upgraded to Package 3",
    "Deposit RS 500 successful via Bank Account",
    "Mehak earned RS 185 from Watching Video",
    "Iqra upgraded to Package 1",
    "Withdrawal RS 1,200 successful via EasyPaisa",
    "Saima earned RS 435 from Watching Video",
    "Sadia upgraded to Package 2",
    "Withdrawal RS 1,550 successful via JazzCash",
    "Nasreen earned RS 305 from Watching Video"

  ];

  const submitHandler = (event) => {
    event.preventDefault();
  };
  return (
    <div className="premium-main-wrapper">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        className="Toaster"
      />
      <Container className="auth-full-screen">
        <Form onSubmit={submitHandler} className="premium-form-card">
          <h1 className="text-center fw-bolder auth-title">
            Sign In
            <span className="auth-icon">
              <FaAccusoft />
            </span>
          </h1>
          <Form.Group className="mb-4 custom-field-group" controlId="formBasicEmail">
            <Form.Label className="premium-label">Email address</Form.Label>
            <Form.Control
              type="email"
              className="premium-input"
              placeholder="Enter email"
              onChange={(e) => {
                SetEmail(e.target.value);
              }}
            />
          </Form.Group>

          <Form.Group className="mb-4 custom-field-group" controlId="formBasicPassword">
            <Form.Label className="premium-label">Password</Form.Label>
            <Form.Control
              type={checkPass ? "text" : "password"}
              className="premium-input"
              placeholder="Password"
              onChange={(e) => {
                SetPassword(e.target.value);
              }}
            />
          </Form.Group>
          <Form.Group className="mb-4" controlId="formBasicCheckbox">
            <Form.Check
              type="checkbox"
              label="Keep me signed in"
              className="m-2 premium-check"
              onClick={() => {
                chkPass();
              }}
            />
          </Form.Group>
          <Button
            variant="outline-success"
            type="submit"
            className="m-1 premium-btn-signin w-100"
            onClick={(e) => signInUser()}
          >
            Sign In
          </Button>
        </Form>
      </Container>

      <Container className="text-center mt-3">
        <Link to="/signup">
          <Button variant="outline-primary" className="m-1 premium-btn-register">
            Don't have an account? Register
          </Button>
        </Link>
      </Container>

      <hr className="premium-divider" />
      <div className="user-activity-section">
        <UserActive />
      </div>
      <hr className="premium-divider" />
      <div className="ticker-wrapper">
        <div className={`ticker-card ${fade ? 'fade-in' : 'fade-out'}`}>
          <div className="pulse-dot"></div>
          <span className="ticker-text">{activities[currentIndex]}</span>
        </div>
      </div>

      {/* <div className="activities-footer">
        <h1 className="text-center activity-headline">Today Activitie's</h1>
        <Container>
          <div className="activity-list-container">
            {items.map((item, index) => (
              <li key={index} className="activity-item">{item} </li>
            ))}
          </div>
        </Container>
      </div> */}
    </div>
  );
};

export default SignIn;
